module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('router-link', {
    staticClass: "postLinkContainer",
    attrs: {
      "to": _vm.to
    }
  }, [_c('img', {
    staticClass: "postThumbnail",
    attrs: {
      "src": _vm.post.acf.pdfImage.sizes.medium
    }
  }), _c('div', {
    staticClass: "info"
  }, [_c('p', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.renderText(_vm.post.acf.displayDate, _vm.post.acf.displayDateEn)))]), _c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.renderText(_vm.post.title.rendered, _vm.post.acf.titleEn)))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-311022a9!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/archive/publications/postLink.vue
// module id = 97
// module chunks = 1